/**
 * Custom checkout — inline walidacja required consent checkboxes.
 *
 * Sprawdza wszystkie `<label data-hn-co-required-consent>` w form'ie — input wewnątrz
 * musi być checked żeby submit przeszedł. Inline error pod każdym osobno; podsumowanie
 * i fokus robi walidator pól, który zbiera ten check razem z błędami pól.
 *
 * Server-side validation w `inc/checkout.php` jest fallback'iem dla user'ów z JS off.
 */
import { registerCheckoutCheck } from './checkout-validation-registry.js';

const CONSENT_LABELS = {
    terms_and_conditions: 'Regulamin i pouczenie o odstąpieniu',
    privacy_policy: 'Polityka prywatności',
};

export function initCheckoutTermsValidate() {
    const form = document.querySelector('form.woocommerce-checkout, form.checkout.hn-co');
    if (!form) return;

    const getConsents = () => Array.from(form.querySelectorAll('[data-hn-co-required-consent]'));
    const getError = (name) => form.querySelector('[data-hn-co-consent-error="' + name + '"]');

    const setError = (label, on) => {
        const input = label.querySelector('input[type="checkbox"]');
        const name = input ? input.name : '';
        const err = name ? getError(name) : null;
        label.classList.toggle('is-invalid', !!on);
        if (err) err.hidden = !on;
        if (input) {
            if (on) input.setAttribute('aria-invalid', 'true');
            else input.removeAttribute('aria-invalid');
        }
    };

    // Klik checkbox'a — czyść jego error gdy zaznaczony.
    document.addEventListener('change', (e) => {
        const cb = e.target;
        if (!cb || cb.type !== 'checkbox') return;
        const label = cb.closest('[data-hn-co-required-consent]');
        if (!label) return;
        if (cb.checked) setError(label, false);
    });

    registerCheckoutCheck(() => getConsents().flatMap((label) => {
        const cb = label.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) {
            setError(label, false);
            return [];
        }
        setError(label, true);
        const err = cb ? getError(cb.name) : null;
        return [{
            el: cb || label,
            label: (cb && CONSENT_LABELS[cb.name]) || 'Wymagana zgoda',
            msg: (err && err.textContent.trim()) || 'Zaznacz, aby kontynuować',
        }];
    }));
}
